import { AxiosService } from './axiosService';

export class ScheduleTreeService extends AxiosService {
    // Omitting componentId returns the schedule-tree roots.
    async getScheduleRoots() {
        return this.getScheduleChildren();
    }

    async getScheduleChildren(componentId) {
        try {
            const params = {};
            if (componentId != null) params.componentId = componentId;
            const { data } = await this.axios.get('/ScheduleTree', { params });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async addScheduleRoot(componentId) {
        try {
            const { data } = await this.axios.post('/scheduletree/root', { componentId });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async addScheduleChild(parentId, childId) {
        try {
            const { data } = await this.axios.post('/scheduletree/child', {
                parentComponentId: parentId,
                childComponentId: childId,
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async removeScheduleRoot(componentId) {
        try {
            const { data } = await this.axios.delete('/scheduletree/root', {
                params: { componentId },
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async removeScheduleChild(parentId, childId) {
        try {
            const { data } = await this.axios.delete('/scheduletree/child', {
                params: { parentComponentId: parentId, childComponentId: childId },
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async moveScheduleNode({ childId, fromParentId = null, toParentId = null }) {
        try {
            const { data } = await this.axios.post('/scheduletree/move', {
                childComponentId: childId,
                fromParentId,
                toParentId,
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }
}

export const scheduleTreeService = new ScheduleTreeService();
